<div>
    <div class="row declaration-checkbox">
        <div class="col-xs-12 col-md-offset-3 col-md-6">
            <mat-checkbox [(ngModel)]="lender50kLimitDeclarationCheck"
                          name="lender50kLimitDeclarationCheck"></mat-checkbox>
            <p class="declaration-text tnc-text">I, hereby confirm that, my investment in each
                of
                the borrowers
                listed below (including the amount I currently propose to invest) does not
                exceed
                &#8377; 50,000
                across all the P2P
                platforms in India.</p>
        </div>
    </div>

    <div class="text-center">
        <button type="button" mat-flat-button class="primary"
                [attr.title]="!this.lender50kLimitDeclarationCheck ? 'Please accept the declaration above' : undefined"
                (click)="autoInvest(gaugedInvestments)"
                [disabled]="!this.lender50kLimitDeclarationCheck"
                *ngIf="!loader">
            CONFIRM INVESTMENT
        </button>
        <mat-spinner [diameter]="35" *ngIf="loader"></mat-spinner>
    </div>
</div>

<p class="text-center">
    In case you want to choose your own loans you can
    switch to <a [routerLink]="" (click)="manualInvest()">manual invest</a> or you can
    <a [routerLink]="" (click)="onInvestLaterClicked()">invest later</a>.
</p>

<div class="row">
    <div class="col-xs-12 col-md-10 col-md-offset-1 table-wrapper">
        <table mat-table [dataSource]="tableDataSource" matSort>
            <ng-container matColumnDef="roi">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ROI %</th>
                <td mat-cell *matCellDef="let element"> {{element.roi | number : '1.2-2'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="rating">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> RATING</th>
                <td mat-cell *matCellDef="let element"> {{element.rating }}</td>
            </ng-container>

            <ng-container matColumnDef="loan_amount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> LOAN AMOUNT</th>
                <td mat-cell *matCellDef="let element">
                    <app-indian-currency-formatter [amount]="element.loanAmount"
                                                   [minimumFractionDigits]="0"></app-indian-currency-formatter>
                </td>
            </ng-container>

            <ng-container matColumnDef="filled_percentage">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> FILLED %</th>
                <td mat-cell *matCellDef="let element"> {{element.filledPercentage | number : '1.2-2'
                    }}
                </td>
            </ng-container>

            <ng-container matColumnDef="loan_data">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> LOAN DETAILS</th>
                <td mat-cell *matCellDef="let element">
                    <a (click)="viewLoanDetails(element.loan)">View Details </a>
                </td>
            </ng-container>

            <ng-container matColumnDef="fund_allocation">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> FUND ALLOCATED</th>
                <td mat-cell *matCellDef="let element">
                    <app-indian-currency-formatter [amount]="element.gaugedInvestmentAmount"
                                                   [minimumFractionDigits]="0"></app-indian-currency-formatter>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator [length]="10"
                       [pageSize]="10"
                       [pageSizeOptions]="[10, 20, 30]">
        </mat-paginator>
    </div>
</div>

<div>
    <div class="row declaration-checkbox">
        <div class="col-xs-12 col-md-offset-3 col-md-6">
            <mat-checkbox [(ngModel)]="lender50kLimitDeclarationCheck"
                          name="lender50kLimitDeclarationCheck"></mat-checkbox>
            <p class="declaration-text tnc-text">I, hereby confirm that, my investment in each
                of
                the borrowers
                listed below (including the amount I currently propose to invest) does not
                exceed
                &#8377; 50,000
                across all the P2P
                platforms in India.</p>
        </div>
    </div>

    <div class="text-center">
        <button type="button" mat-flat-button class="primary"
                [attr.title]="!this.lender50kLimitDeclarationCheck ? 'Please accept the declaration above' : undefined"
                (click)="autoInvest(gaugedInvestments)"
                [disabled]="!this.lender50kLimitDeclarationCheck"
                *ngIf="!loader">
            CONFIRM INVESTMENT
        </button>
        <mat-spinner [diameter]="35" *ngIf="loader"></mat-spinner>
    </div>
</div>